import axios from "axios";
import { API } from "configs/api";

export const dashboardApi = {
  getDashboardList: (params) => axios.get(`${API.admin}${API.dashboard}`, { token: true, params }),
};
